import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Separator } from '../ui/separator';
import { Play, Square, Pause, RefreshCw, Volume2, VolumeX, Settings } from 'lucide-react';

const BotControlsCard = ({
  botStatus,
  tradingMode,
  audioAlertsEnabled,
  handleStartBot,
  handlePauseBot,
  handleStopBot,
  handleResetPortfolio,
  toggleAudioAlerts,
}) => {
  return (
    <Card className="matrix-card rounded-none" data-testid="controls-card">
      <CardHeader className="border-b border-[#003B00] p-4">
        <CardTitle className="text-sm uppercase tracking-widest flex items-center gap-2">
          <Settings className="h-4 w-4" strokeWidth={1.5} />
          BOT CONTROLS
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm uppercase">STATUS</span>
          <Badge
            className={`rounded-none uppercase ${
              botStatus === 'running'
                ? 'bg-green-900/20 text-[#00FF41] border-[#00FF41]'
                : botStatus === 'paused'
                ? 'bg-yellow-900/20 text-[#F3F9D2] border-[#F3F9D2]'
                : 'bg-red-900/20 text-red-500 border-red-500'
            }`}
            data-testid="bot-status"
          >
            <span className={`mr-2 inline-block w-2 h-2 rounded-full ${
              botStatus === 'running' ? 'bg-[#00FF41] animate-pulse' : 
              botStatus === 'paused' ? 'bg-[#F3F9D2]' : 'bg-red-500'
            }`} />
            {botStatus.toUpperCase()}
          </Badge>
        </div>

        <div className="grid grid-cols-3 gap-2">
          <Button
            onClick={handleStartBot}
            disabled={botStatus === 'running'}
            className="matrix-btn rounded-none"
            data-testid="start-bot-btn"
          >
            <Play className="h-4 w-4 mr-1" strokeWidth={1.5} />
            START
          </Button>
          <Button
            onClick={handlePauseBot}
            disabled={botStatus !== 'running'}
            className="matrix-btn rounded-none"
            data-testid="pause-bot-btn"
          >
            <Pause className="h-4 w-4 mr-1" strokeWidth={1.5} />
            PAUSE
          </Button>
          <Button
            onClick={handleStopBot}
            disabled={botStatus === 'stopped'}
            className="matrix-btn rounded-none border-red-500 text-red-500 hover:bg-red-500 hover:text-black"
            data-testid="stop-bot-btn"
          >
            <Square className="h-4 w-4 mr-1" strokeWidth={1.5} />
            STOP
          </Button>
        </div>

        <Separator className="bg-[#003B00]" />

        {tradingMode !== 'live' && (
          <Button
            onClick={handleResetPortfolio}
            disabled={botStatus === 'running'}
            className="w-full matrix-btn rounded-none"
            data-testid="reset-btn"
          >
            <RefreshCw className="h-4 w-4 mr-2" strokeWidth={1.5} />
            RESET PORTFOLIO
          </Button>
        )}

        <Button
          onClick={toggleAudioAlerts}
          className={`w-full matrix-btn rounded-none mt-2 ${audioAlertsEnabled ? 'border-[#00FF41] text-[#00FF41]' : 'border-gray-500 text-gray-500 hover:bg-gray-500 hover:text-black'}`}
          data-testid="audio-alerts-btn"
        >
          {audioAlertsEnabled ? (
            <><Volume2 className="h-4 w-4 mr-2" strokeWidth={1.5} />AUDIO ALERTS ON</>
          ) : (
            <><VolumeX className="h-4 w-4 mr-2" strokeWidth={1.5} />AUDIO ALERTS OFF</>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default BotControlsCard;
